<script setup lang="ts">
import {defineProps} from 'vue'
const props = defineProps({
  carrouselElement:{type:Array, default: ()=> []}
});
const baseUrls = "https://strapi.citesainteaugustine-ci.com"
console.log(props.carrouselElement)
</script>

<template>
  <div class="impx-slideshow uk-margin-large-top">

    <div class="uk-position-relative uk-visible-toggle uk-light uk-height-1-1" data-uk-slideshow="min-height: 220; max-height: 660; animation: fade">

      <ul class="uk-slideshow-items">
        <li  v-for="(item,index) in props.carrouselElement" :key="index">
          <!-- slideshow item #1 -->
          <div class="uk-position-cover uk-animation-kenburns uk-animation-reverse uk-transform-origin-center-left">
            <img :src="baseUrls+item?.slideImage?.url??''" alt="" class="slide 1" data-uk-cover>
          </div>
          <div class="impx-slide-caption uk-box-shadow-small">
            <h3 class="uk-margin-remove impx-text-gold">{{item.title}}</h3>
            <p class="impx-text-large uk-margin-remove impx-text-aqua">
              {{item.subtitle}}
            </p>
          </div>
        </li>
        <!-- slideshow item #1 end -->
      </ul>

      <!-- slideshow nav -->
      <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous data-uk-slideshow-item="previous"></a>
      <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next data-uk-slideshow-item="next"></a>
      <!-- slideshow nav end -->

      <!-- slideshow dot nav -->
      <ul class="uk-dotnav uk-dotnav-contrast uk-flex-center uk-position-z-index impx-slide-nav">
        <li data-uk-slideshow-item="{{index}}" v-for="(item,index) in props.carrouselElement" :key="index"><a href="#"></a></li>
<!--        <li data-uk-slideshow-item="3"><a href="#"></a></li>-->
      </ul>
      <!-- slideshow dot nav end -->

    </div>
  </div>

</template>

<style scoped>

</style>